import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { Login } from '../pages/login/Login.page';
import { ReduxStateProvider } from '../state/reduxStateProvider';
import { guardianRoutes } from '../guardianApp/routes/guardianRoutes';
import { orgRoutes } from '../orgApp/routes/orgRoutes';
import { clinicRoutes } from '../clinicApp/routes/clinicRoutes';
import { SignUp } from '../pages/signUp/signUp.page';
import { ForgotPassword } from '../pages/forgotPassword/forgotPassword.page';
import { ErrorPage } from '../components/errorPage/errorPage';
import { SplashScreen } from '../pages/login/components/welcomeScreen/splashScreen';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <ReduxStateProvider />,
    errorElement: <ErrorPage />,
    children: [
      {
        // path: '/login',
        index: true,
        element: window.innerWidth <= 700 ? <SplashScreen /> : <Login />,
      },
      {
        path: '/login',
        index: true,
        element: <Login />,
      },
      {
        path: '/signup',
        index: true,
        element: <SignUp />,
      },
      {
        path: '/forgot-password',
        index: true,
        element: <ForgotPassword />,
      },

      clinicRoutes,
      guardianRoutes,
      orgRoutes,
    ],
  },
]);
